const RETURN_URL_STORAGE_KEY = 'AUTH_RETURN_URL'

/**
 * Безопасный returnUrl: допускаются только внутренние пути
 * (начинаются с одного '/'), чтобы через query-параметр нельзя было
 * подставить внешнюю ссылку (open redirect).
 */
export function getSafeReturnUrl(value: string | null): string | null {
  if (value == null || value === '' || value === '/') {
    return null
  }

  return value.startsWith('/') && !value.startsWith('//') ? value : null
}

/**
 * Возврат на исходную страницу, сохранённый перед регистрацией/входом
 * (его кладёт сюда экран авторизации из query-параметра returnUrl).
 */
export function getStoredReturnUrl(): string | null {
  return getSafeReturnUrl(localStorage.getItem(RETURN_URL_STORAGE_KEY))
}

export function storeReturnUrl(value: string): void {
  localStorage.setItem(RETURN_URL_STORAGE_KEY, value)
}

export function clearStoredReturnUrl(): void {
  localStorage.removeItem(RETURN_URL_STORAGE_KEY)
}
